import React, { useEffect, useState } from 'react';
import { getStaff } from '../constants/api';
import { useAuth } from '../constants/AuthContext';
import { COLORS } from '../constants/theme';

export default function StaffPage() {
  const { user } = useAuth();
  const [staff, setStaff] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    getStaff()
      .then(res => setStaff(res.data))
      .catch(err => console.log(err.message))
      .finally(() => setLoading(false));
  }, []);

  if (loading) return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center', height: '100vh', color: COLORS.accent }}>
      Loading...
    </div>
  );

  return (
    <div style={{ padding: 32, maxWidth: 900, margin: '0 auto' }}>

      {/* Header */}
      <div style={{ marginBottom: 28 }}>
        <div style={{ fontSize: 26, fontWeight: 900, color: COLORS.ink }}>Staff Members</div>
        <div style={{ fontSize: 14, color: COLORS.inkLight, marginTop: 4 }}>
          {staff.length} {staff.length === 1 ? 'member' : 'members'} in your business
        </div>
      </div>

      {/* Business code card */}
      <div style={{ background: COLORS.accentLight, borderRadius: 16, padding: 24, border: `1px solid #B6DFC7`, marginBottom: 28, display: 'flex', justifyContent: 'space-between', alignItems: 'center' }}>
        <div>
          <div style={{ fontSize: 11, fontWeight: 700, color: COLORS.accent, letterSpacing: 1.5, textTransform: 'uppercase', marginBottom: 6 }}>
            Your Business Code
          </div>
          <div style={{ fontSize: 32, fontWeight: 900, color: COLORS.accent, letterSpacing: 4 }}>
            {user?.businessCode}
          </div>
          <div style={{ fontSize: 13, color: COLORS.inkMid, marginTop: 6 }}>
            Share this code with your staff so they can join your business
          </div>
        </div>
        <button
          onClick={() => {
            navigator.clipboard.writeText(user?.businessCode ?? '');
            alert('Business code copied!');
          }}
          style={{ background: COLORS.accent, color: 'white', border: 'none', borderRadius: 12, padding: '12px 20px', fontSize: 14, fontWeight: 700, cursor: 'pointer', fontFamily: 'inherit' }}
        >
          Copy Code
        </button>
      </div>

      {/* Staff list */}
      {staff.length === 0 ? (
        <div style={{ background: 'white', borderRadius: 16, padding: 60, border: `1px solid ${COLORS.border}`, textAlign: 'center' }}>
          <div style={{ fontSize: 40, marginBottom: 12 }}>👥</div>
          <div style={{ fontSize: 16, fontWeight: 700, color: COLORS.ink, marginBottom: 8 }}>No staff yet</div>
          <div style={{ fontSize: 13, color: COLORS.inkLight, marginBottom: 20 }}>
            Share your business code with staff so they can register and join your business.
          </div>
          <div style={{ background: COLORS.accentLight, borderRadius: 12, padding: '16px 24px', display: 'inline-block' }}>
            <div style={{ fontSize: 22, fontWeight: 900, color: COLORS.accent, letterSpacing: 3 }}>{user?.businessCode}</div>
          </div>
        </div>
      ) : (
        <div style={{ background: 'white', borderRadius: 16, border: `1px solid ${COLORS.border}`, overflow: 'hidden' }}>
          {/* Table header */}
          <div style={{ display: 'grid', gridTemplateColumns: '2fr 2fr 2fr 1fr 1fr', padding: '12px 20px', background: COLORS.bg, borderBottom: `1px solid ${COLORS.border}` }}>
            {['Name', 'Username', 'Email', 'Role', 'Status'].map(h => (
              <div key={h} style={{ fontSize: 11, fontWeight: 700, color: COLORS.inkLight, textTransform: 'uppercase', letterSpacing: 1 }}>{h}</div>
            ))}
          </div>

          {staff.map((member, i) => (
            <div
              key={member.id}
              style={{ display: 'grid', gridTemplateColumns: '2fr 2fr 2fr 1fr 1fr', padding: '16px 20px', borderBottom: i < staff.length - 1 ? `1px solid ${COLORS.border}` : 'none', alignItems: 'center' }}
            >
              {/* Avatar + name */}
              <div style={{ display: 'flex', alignItems: 'center', gap: 12 }}>
                <div style={{ width: 36, height: 36, borderRadius: 10, background: COLORS.accentLight, display: 'flex', alignItems: 'center', justifyContent: 'center', fontSize: 14, fontWeight: 900, color: COLORS.accent, flexShrink: 0 }}>
                  {member.fullName?.charAt(0).toUpperCase()}
                </div>
                <div style={{ fontSize: 14, fontWeight: 700, color: COLORS.ink }}>{member.fullName}</div>
              </div>

              <div style={{ fontSize: 13, color: COLORS.inkMid }}>@{member.username}</div>
              <div style={{ fontSize: 13, color: COLORS.inkMid }}>{member.email}</div>

              {/* Role badge */}
              <div style={{ display: 'inline-flex' }}>
                <span style={{ background: COLORS.accentLight, color: COLORS.accent, fontSize: 11, fontWeight: 700, padding: '4px 10px', borderRadius: 20 }}>
                  Staff
                </span>
              </div>

              {/* Verified status */}
              <div style={{ display: 'flex', alignItems: 'center', gap: 6 }}>
                <div style={{ width: 8, height: 8, borderRadius: '50%', background: member.isVerified ? COLORS.accent : COLORS.danger }} />
                <span style={{ fontSize: 12, color: member.isVerified ? COLORS.accent : COLORS.danger, fontWeight: 600 }}>
                  {member.isVerified ? 'Verified' : 'Unverified'}
                </span>
              </div>
            </div>
          ))}
        </div>
      )}
    </div>
  );
}